import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import SlidingTab from '../../../../components/SlidingTab/SlidingTab';
import useDashboardStore from "../../../../stores/dashboard";
import Spinner from '../../../../components/Loaders/Spinner';
import moment from 'moment';

// Function to format numbers with K, M, B suffixes
const formatNumber = (num) => {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1) + 'B';
  } else if (num >= 1000000) {
    return (num / 1000000).toFixed(1) + 'M';
  } else if (num >= 1000) {
    return (num / 1000).toFixed(1) + 'K';
  }
  return num.toString();
};

const TrendUp = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M22.5001 5.25V11.25C22.5001 11.4489 22.421 11.6397 22.2804 11.7803C22.1397 11.921 21.949 12 21.7501 12C21.5511 12 21.3604 11.921 21.2197 11.7803C21.0791 11.6397 21.0001 11.4489 21.0001 11.25V7.06031L13.2807 14.7806C13.211 14.8504 13.1283 14.9057 13.0373 14.9434C12.9462 14.9812 12.8486 15.0006 12.7501 15.0006C12.6515 15.0006 12.5539 14.9812 12.4628 14.9434C12.3718 14.9057 12.2891 14.8504 12.2194 14.7806L9.00005 11.5603L2.78068 17.7806C2.63995 17.9214 2.44907 18.0004 2.25005 18.0004C2.05103 18.0004 1.86016 17.9214 1.71943 17.7806C1.5787 17.6399 1.49963 17.449 1.49963 17.25C1.49963 17.051 1.5787 16.8601 1.71943 16.7194L8.46943 9.96937C8.53908 9.89964 8.6218 9.84432 8.71285 9.80658C8.80389 9.76884 8.90149 9.74941 9.00005 9.74941C9.09861 9.74941 9.19621 9.76884 9.28726 9.80658C9.3783 9.84432 9.46102 9.89964 9.53068 9.96937L12.7501 13.1897L19.9397 6H15.7501C15.5511 6 15.3604 5.92098 15.2197 5.78033C15.0791 5.63968 15.0001 5.44891 15.0001 5.25C15.0001 5.05109 15.0791 4.86032 15.2197 4.71967C15.3604 4.57902 15.5511 4.5 15.7501 4.5H21.7501C21.949 4.5 22.1397 4.57902 22.2804 4.71967C22.421 4.86032 22.5001 5.05109 22.5001 5.25Z" fill="#37B450" />
    </svg>
  )
}

const TrendDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M22.5001 12V18C22.5001 18.1989 22.421 18.3897 22.2804 18.5303C22.1397 18.671 21.949 18.75 21.7501 18.75H15.7501C15.5511 18.75 15.3604 18.671 15.2197 18.5303C15.0791 18.3897 15.0001 18.1989 15.0001 18C15.0001 17.8011 15.0791 17.6103 15.2197 17.4697C15.3604 17.329 15.5511 17.25 15.7501 17.25H19.9397L12.7501 10.0603L9.53068 13.2806C9.46102 13.3504 9.3783 13.4057 9.28726 13.4434C9.19621 13.4812 9.09861 13.5006 9.00005 13.5006C8.90149 13.5006 8.80389 13.4812 8.71285 13.4434C8.6218 13.4057 8.53908 13.3504 8.46943 13.2806L1.71943 6.53062C1.5787 6.38989 1.49963 6.19902 1.49963 6C1.49963 5.80097 1.5787 5.6101 1.71943 5.46937C1.86016 5.32864 2.05103 5.24958 2.25005 5.24958C2.44907 5.24958 2.63995 5.32864 2.78068 5.46937L9.00005 11.6897L12.2194 8.46937C12.2891 8.39964 12.3718 8.34432 12.4628 8.30658C12.5539 8.26883 12.6515 8.24941 12.7501 8.24941C12.8486 8.24941 12.9462 8.26883 13.0373 8.30658C13.1283 8.34432 13.211 8.39964 13.2807 8.46937L21.0001 16.1897V12C21.0001 11.8011 21.0791 11.6103 21.2197 11.4697C21.3604 11.329 21.5511 11.25 21.7501 11.25C21.949 11.25 22.1397 11.329 22.2804 11.4697C22.421 11.6103 22.5001 11.8011 22.5001 12Z" fill="#E03B24" />
    </svg>
  )
}

const TopResidual = () => {
  const [topResidual, setTopResidual] = useState([]);
  const [loading, setLoading] = useState(true);

  const filterStartDate = useDashboardStore((s) => s.filterData.startDate);
  const filterEndDate = useDashboardStore((s) => s.filterData.endDate);

  useEffect(() => {
    setLoading(false);
  }, []);
  return (
    <div className={styles.activeMerchant} >
      <div className={styles.activeMerchantHeader} >
        <div className={styles.activeMerchantHeaderContent} >
          <p className={styles.activeMerchantHeaderTitle} >Top Residual</p>
          <p className={styles.activeMerchantHeaderDate} >{moment(filterStartDate).format('DD MMM YYYY')} - {moment(filterEndDate).format('DD MMM YYYY')}</p>
        </div>
      </div>

      {loading && (
        <div className={styles.activeMerchantLoading} >
          <Spinner />
        </div>
      )}

      {!loading && (
        <>
          {topResidual?.length > 0 ? (
            <div className={styles.activeMerchantList} >
              {topResidual.map((merchant, index) => (
                <div key={index} className={styles.activeMerchantListItem} >
                  <div className={styles.activeMerchantListItemContent} >
                    <p className={styles.activeMerchantListItemTitle} >{merchant.powerapp_name}</p>
                    <p className={styles.activeMerchantListItemDescription} >{merchant.total_sales.toLocaleString()}</p>
                  </div>

                  <div className={styles.amountContainer} >
                    <p className={styles.amountValue} >${formatNumber(merchant.total_sales)}</p>
                  </div>

                  <div className={styles.trendContainer} >
                    <span className={styles.trendIcon} >
                      {merchant.trend == 'up' ? (
                        <TrendUp />
                      ) : (
                        <TrendDown />
                      )}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className={styles.emptyContainer} >
              <div className={styles.iconBox} >
                <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                  <path d="M13.1667 10C13.1667 9.66848 13.2984 9.35054 13.5329 9.11612C13.7673 8.8817 14.0852 8.75 14.4167 8.75H34.4167C34.7483 8.75 35.0662 8.8817 35.3006 9.11612C35.5351 9.35054 35.6667 9.66848 35.6667 10C35.6667 10.3315 35.5351 10.6495 35.3006 10.8839C35.0662 11.1183 34.7483 11.25 34.4167 11.25H14.4167C14.0852 11.25 13.7673 11.1183 13.5329 10.8839C13.2984 10.6495 13.1667 10.3315 13.1667 10ZM34.4167 18.75H14.4167C14.0852 18.75 13.7673 18.8817 13.5329 19.1161C13.2984 19.3505 13.1667 19.6685 13.1667 20C13.1667 20.3315 13.2984 20.6495 13.5329 20.8839C13.7673 21.1183 14.0852 21.25 14.4167 21.25H34.4167C34.7483 21.25 35.0662 21.1183 35.3006 20.8839C35.5351 20.6495 35.6667 20.3315 35.6667 20C35.6667 19.6685 35.5351 19.3505 35.3006 19.1161C35.0662 18.8817 34.7483 18.75 34.4167 18.75ZM34.4167 28.75H14.4167C14.0852 28.75 13.7673 28.8817 13.5329 29.1161C13.2984 29.3505 13.1667 29.6685 13.1667 30C13.1667 30.3315 13.2984 30.6495 13.5329 30.8839C13.7673 31.1183 14.0852 31.25 14.4167 31.25H34.4167C34.7483 31.25 35.0662 31.1183 35.3006 30.8839C35.5351 30.6495 35.6667 30.3315 35.6667 30C35.6667 29.6685 35.5351 29.3505 35.3006 29.1161C35.0662 28.8817 34.7483 28.75 34.4167 28.75ZM7.54175 8.125C7.17091 8.125 6.8084 8.23497 6.50005 8.44099C6.19171 8.64702 5.95139 8.93986 5.80947 9.28247C5.66756 9.62508 5.63043 10.0021 5.70278 10.3658C5.77512 10.7295 5.9537 11.0636 6.21592 11.3258C6.47815 11.588 6.81224 11.7666 7.17595 11.839C7.53967 11.9113 7.91667 11.8742 8.25928 11.7323C8.60189 11.5904 8.89473 11.35 9.10075 11.0417C9.30678 10.7334 9.41675 10.3708 9.41675 10C9.41675 9.50272 9.21921 9.02581 8.86757 8.67417C8.51594 8.32254 8.03903 8.125 7.54175 8.125ZM7.54175 18.125C7.17091 18.125 6.8084 18.235 6.50005 18.441C6.19171 18.647 5.95139 18.9399 5.80947 19.2825C5.66756 19.6251 5.63043 20.0021 5.70278 20.3658C5.77512 20.7295 5.9537 21.0636 6.21592 21.3258C6.47815 21.588 6.81224 21.7666 7.17595 21.839C7.53967 21.9113 7.91667 21.8742 8.25928 21.7323C8.60189 21.5904 8.89473 21.35 9.10075 21.0417C9.30678 20.7334 9.41675 20.3708 9.41675 20C9.41675 19.5027 9.21921 19.0258 8.86757 18.6742C8.51594 18.3225 8.03903 18.125 7.54175 18.125ZM7.54175 28.125C7.17091 28.125 6.8084 28.235 6.50005 28.441C6.19171 28.647 5.95139 28.9399 5.80947 29.2825C5.66756 29.6251 5.63043 30.0021 5.70278 30.3658C5.77512 30.7295 5.9537 31.0636 6.21592 31.3258C6.47815 31.588 6.81224 31.7666 7.17595 31.839C7.53967 31.9113 7.91667 31.8742 8.25928 31.7323C8.60189 31.5904 8.89473 31.35 9.10075 31.0417C9.30678 30.7334 9.41675 30.3708 9.41675 30C9.41675 29.5027 9.21921 29.0258 8.86757 28.6742C8.51594 28.3225 8.03903 28.125 7.54175 28.125Z" fill="#A4A3A8" />
                </svg>
              </div>

              <p className={styles.emptyTitle} >
                This card will display merchants generating the highest residual income during the selected period
              </p>
            </div>
          )}
        </>
      )}

    </div>
  )
}

export default TopResidual;